import ScreenWipe from "./ScreenWipe";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { currentLevelSelector } from "../../atoms/currentLevelAtom";

export default function LevelCompletedTransition({ level, onGoToEndingScene }) {
  const [isShowingScreenWipe, setIsShowingScreenWipe] = useState(false);
  const [currentLevel] = useRecoilState(currentLevelSelector);

  //One way change to mount the component on level complete
  useEffect(() => {
    if (level.isLevelCompleted) {
      setIsShowingScreenWipe(true);
    }
  }, [currentLevel, level.isLevelCompleted]);

  if (!isShowingScreenWipe) {
    return null;
  }

  return (
    <ScreenWipe
      onCompleteLastLevel={() => {
        onGoToEndingScene();
      }}
      onDone={() => {
        setIsShowingScreenWipe(false);
      }}
    />
  );
}
